import React from 'react';
import { Link } from 'react-router-dom';
import { FaExclamationTriangle } from 'react-icons/fa';
import { useSession } from '../context/SessionContext';

export default function SessionBanner() {
  const { hasActiveSession, loading, sessions } = useSession();

  // Don't show while loading, or if user has no sessions at all (brand new user)
  if (loading || sessions.length === 0) return null;

  // All good, at least one session is connected
  if (hasActiveSession) return null;

  return (
    <div className="flex items-center gap-3 px-4 py-2.5 text-sm bg-red-50 border-b border-red-200 text-red-700">
      <FaExclamationTriangle className="shrink-0 text-red-500" />
      <span>
        Your WhatsApp is not connected. Messages, campaigns, and other features won't work until you reconnect.
      </span>
      <Link
        to="/whatsapp-phones"
        className="ml-auto shrink-0 px-3 py-1 text-xs font-medium rounded bg-red-600 text-white hover:bg-red-700 transition-colors"
      >
        Connect Now
      </Link>
    </div>
  );
}
